import React from 'react';
import { useTranslation } from 'react-i18next';

const OurMission = () => {
  const { t } = useTranslation();
  const missions = t('mission', { returnObjects: true });
  return (
    <section className="section" id="our-mission">
      <span className="section-title">{t('sections.ourMission')}</span>
      <div className="services">
        <p>{t('ourMissionText')}</p>
        {Object.entries(missions).map(([key, mission]) => (
          <div className="service" key={key}>
            <h3>{t(`${mission.title}`)}</h3>
            <p>{t(`${mission.description}`)}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default OurMission;
